import React, { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import {Trans} from '@lingui/macro'
import { XIcon } from '@heroicons/react/outline'

import {typeDProductsFilters} from '../../dataProducts/filters'

// Type
export type typeFilterBarDashboard = {
    openFilterBar: boolean | undefined
    setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>,
    filtersForm: React.ReactElement<typeDProductsFilters>
}


// Component
export const FilterBarDashboard: React.FC<typeFilterBarDashboard> = ({openFilterBar, setOpenFilterBar, filtersForm}) => {

    return(
        <Transition.Root show={openFilterBar} as={Fragment}>
            <Dialog as="div" static className="fixed inset-0 overflow-hidden" open={openFilterBar} onClose={setOpenFilterBar}>
                <div className="absolute inset-0 overflow-hidden">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-in-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in-out duration-300"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-y-0 right-0 pl-10 max-w-full flex">
                        <Transition.Child
                            as={Fragment}
                            enter="transform transition ease-in-out duration-500 sm:duration-500"
                            enterFrom="translate-x-full"
                            enterTo="translate-x-0"
                            leave="transform transition ease-in-out duration-500 sm:duration-500"
                            leaveFrom="translate-x-0"
                            leaveTo="translate-x-full"
                        >
                            <div className="w-screen max-w-md">

                                <div className="h-full flex flex-col py-6 bg-white shadow-xl overflow-y-scroll divide-y">

                                    <div className="px-4 sm:px-6 mb-6">
                                        <div className="flex items-start justify-between">
                                            <Dialog.Title className="text-lg font-medium text-gray-900"><Trans>Filter bar</Trans></Dialog.Title>
                                            <div className="ml-3 h-7 flex items-center">
                                                <button
                                                    className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                    onClick={() => setOpenFilterBar(false)}
                                                >
                                                    <span className="sr-only"><Trans>Close filter panel</Trans></span>
                                                    <XIcon className="h-6 w-6" aria-hidden="true" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-6 relative flex-1 px-4 sm:px-6">

                                        {filtersForm}

                                    </div>

                                </div>

                            </div>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
